

























































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import ReturObatVerifikasiItemRow from "./ReturObatVerifikasiItemRow.vue";
import ReturObatSvc from "@/services/ReturObatService";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: {
    CardModalTtd,
    ReturObatVerifikasiItemRow,
  }
})
export default class ReturObatVerifikasi extends Vue {
  @Prop() retur!: any;

  localItems: any[] = [];
  modalTtd = false;

  alasanMap: Record<string, string> = {
    pasien_pulang: "Pasien Pulang",
    terapi_berubah: "Perubahan Terapi",
    efek_samping: "Efek Samping/Alergi",
    pasien_meninggal: "Pasien Meninggal",
    pasien_pindah: "Pasien Pindah",
    salah_dispensing: "Salah Dispensing",
    expired: "Expired",
    rusak: "Rusak",
    lainnya: "Lainnya",
  };

  tableHeaders = [
    { text: "No", value: "no", width: "40px", sortable: false },
    { text: "Nama Item", value: "nama_item" },
    { text: "Jumlah", value: "jumlah_retur", width: "70px" },
    { text: "Kondisi", value: "label_kondisi", width: "100px" },
    { text: "Batch", value: "batch_no", width: "100px" },
    { text: "Expired", value: "expired_date", width: "120px" },
    { text: "Harga Satuan", value: "harga_satuan", width: "110px" },
    { text: "Verifikasi", value: "aksi", width: "220px", sortable: false },
  ];

  mounted() {
    this.localItems = JSON.parse(JSON.stringify(this.retur.items || []));
  }

  get isLocked() {
    return this.retur.is_locked;
  }

  get allVerified() {
    return this.localItems.length > 0 &&
      this.localItems.every((i: any) => i.status_terima !== null);
  }

  alasanLabel(key: string) {
    return this.alasanMap[key] || key;
  }

  formatDateTime(date: string) {
    return getHumanDateTime(date);
  }

  async onVerifyItem(payload: { itemId: number; status_terima: string; alasan_tolak?: string }) {
    try {
      const item = this.localItems.find((i: any) => i.id === payload.itemId);
      const data: any = {
        status_terima: payload.status_terima,
        alasan_tolak: payload.alasan_tolak || null,
      };
      if (item) {
        data.batch_no = item.batch_no;
        data.expired_date = item.expired_date;
        data.harga_satuan = item.harga_satuan;
      }

      await ReturObatSvc.verifyItem(this.retur.id, payload.itemId, data);
      appModule.NoticeDelay(`Item berhasil di${payload.status_terima}`);

      // Update local state
      if (item) {
        item.status_terima = payload.status_terima;
        item.alasan_tolak = payload.alasan_tolak || null;
      }
    } catch {
      // handled by service
    }
  }

  async bulkTerima() {
    const items = this.localItems.map((i: any) => ({
      id: i.id,
      status_terima: "diterima",
      batch_no: i.batch_no,
      expired_date: i.expired_date,
      harga_satuan: i.harga_satuan,
    }));

    try {
      await ReturObatSvc.verifyBulk(this.retur.id, { items });
      appModule.NoticeDelay("Semua item berhasil diterima");
      this.localItems.forEach((i: any) => {
        i.status_terima = "diterima";
        i.alasan_tolak = null;
      });
    } catch {
      // handled by service
    }
  }

  openTtdFarmasi() {
    this.modalTtd = true;
  }

  async passTtdFarmasi(password: string) {
    try {
      const resp = await ReturObatSvc.signFarmasi(this.retur.id, { password });

      if (resp.data.status == "1") {
        this.modalTtd = false;
        appModule.NoticeDelay("Retur berhasil difinalisasi oleh Farmasi");
        appModule.addMsgTtd("");
        this.$emit("verified");
      } else {
        appModule.addMsgTtd(resp.data.message);
        this.modalTtd = true;
      }
    } catch {
      // handled by service
    }
  }
}
